export const moduleName = 'financeManagementModule';
